import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { get } from 'lodash'
import { ParticipantsPreparationTrainings } from 'containers/forms/aj-preparation-trainings'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { ButtonGroup, Button } from 'components/misc'
import { apiAwards } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'
import { AJ_TRAINING_PROGRESS_STATES } from 'constants/enums'

@meta({
  title: 'AJ Preparation and training'
})
@apiAwards({
  detail: true,
  preparationTrainings: true,
  redirectToTasks: true,
  pushToParticipantDetail: true
})
class AwardPreparationTraining extends Component {
  static propTypes = {
    awards: PropTypes.object.isRequired,
    approveAjPreparationTraining: PropTypes.func.isRequired,
    returnAjPreparationTraining: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      ajPrepTrainingId: null,
      ajPrepTrainingIdReturn: null
    }
  }

  handleApproveParticipantEventModal = ajPrepTrainingId => {
    this.setState(
      {
        ajPrepTrainingId
      },
      () => {
        this.props.modal(`modal-approve-aj-participant-event-${this.key}`)
      }
    )
  }

  handleReturnParticipantEventModal = ajPrepTrainingIdReturn => {
    this.setState(
      {
        ajPrepTrainingIdReturn
      },
      () => {
        this.props.modal(`modal-return-aj-participant-event-${this.key}`)
      }
    )
  }

  render() {
    const {
      awards,
      approveAjPreparationTraining,
      returnAjPreparationTraining
    } = this.props

    return (
      <div>
        <div className="row">
          <div className="col-xs-8">
            <Title h2 intlKey="moduleTitle.aj_preparation_and_training">
              AJ preparation & training
            </Title>
          </div>
          <div className="col-xs-4">
            {get(awards, 'detail.id') &&
              <ButtonGroup right>
                <Button
                  intlKey="button.approve"
                  onClick={() =>
                    this.handleApproveParticipantEventModal(
                      get(awards, 'detail.id')
                    )}
                  disabled={
                    get(
                      awards,
                      'detail.ajPreparationAndTrainingStateType.value'
                    ) !== AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id
                  }
                >
                  Approve
                </Button>
                <Button
                  intlKey="button.revise"
                  onClick={() =>
                    this.handleReturnParticipantEventModal(
                      get(awards, 'detail.id')
                    )}
                  disabled={
                    get(
                      awards,
                      'detail.ajPreparationAndTrainingStateType.value'
                    ) !== AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id
                  }
                  secondary
                >
                  Revise
                </Button>
              </ButtonGroup>}
          </div>
        </div>
        <ParticipantsPreparationTrainings {...this.props} />
        <Modal
          id={`modal-approve-aj-participant-event-${this.key}`}
          customActions
        >
          <TaskApprove
            id={this.state.ajPrepTrainingId}
            approve={approveAjPreparationTraining}
            modal={this.props.modal}
          />
        </Modal>
        <Modal
          id={`modal-return-aj-participant-event-${this.key}`}
          customActions
        >
          <TaskReturn
            returnTask={returnAjPreparationTraining}
            id={this.state.ajPrepTrainingIdReturn}
            modal={this.props.modal}
          />
        </Modal>
      </div>
    )
  }
}

export default AwardPreparationTraining
